import react, { useState, useEffect } from "react";
import { linkTo } from "../../utils/uiUtils";
import { Link } from "react-router-dom";
import { ethers } from "ethers";
import { createClient } from "@supabase/supabase-js";
//Hooks
import { useAcreDapp } from "../../providers/AcreDappProvider/AcreDappProvider";
import useOwnedNFTs from "../../hooks/useOwnedNFTs";
import { useConnectWallet, useWallets } from "@web3-onboard/react";
// components
import RoundedButton from "../RoundedButton/RoundedButton";
import NavItem from "../NavItem/NavItem";

// media
import horizontalLogoGreenImg from "../../media/horizontal-logo-green.svg";
import circleLogoGreenImg from "../../media/circle-logo-green.svg";
import { blob } from "stream/consumers";


function Navbar(props: {
  bg?: "transparent" | "white" | "grey";
  hideLogo?: boolean;
}) {
  const [loading, setLoading] = useState(false);
  const [{ wallet, connecting }, connect, disconnect] = useConnectWallet();
  const { ownedNFTs } = useOwnedNFTs();
  const { walletContext, currentWalletState } = useAcreDapp();
  const supabase = createClient(
    `https://${process.env.REACT_APP_SUPABASE_URL}.supabase.co`,
    `${process.env.REACT_APP_SUPABASE_API_KEY}`
  );
  let ethersProvider;
  useEffect(() => {
    if (wallet) {
      ethersProvider = new ethers.providers.Web3Provider(
        wallet.provider,
        "any"
      );
      let web3 = document.querySelector("onboard-v2") as HTMLElement;
      web3.style.display = "none";
      const nakedDB = async () => {
        try {
            setLoading(true);  
          let { data, error, status } = await supabase
            .from("Users")
            .upsert({
              wallet_address: wallet?.accounts[0].address,
              NFTS: ownedNFTs,
            })
            .eq("wallet_address", wallet?.accounts[0].address);
          if (error && status !== 406) {
            throw error;
          }
          if(status){
            console.log("Database status: ", status, data);
          };
        } catch (error) {
          console.table(error);
        } finally {
          setLoading(false);
        }
      };
      nakedDB();
    } else {
      let web3 = document.querySelector("onboard-v2") as HTMLElement;
      web3.style.display = "";
    }
  }, [wallet, walletContext, currentWalletState]);

  let bgClasses = "bg-white";
  let hideLogoClasses = props.hideLogo ? "invisible" : "";

  switch (props.bg) {
    case "transparent":
      bgClasses = "";
      break;
    case "white":
      bgClasses = "bg-white";
      break;
    case "grey":
      bgClasses = "bg-lighter-grey";
      break;
    default:
      bgClasses = "bg-blue";
      break;
  }

  return (
    <nav
      className={`${bgClasses} z-10 relative px-6 md:px-20 py-auto sm:h-nav-sm md:h-nav-md lg:h-nav-lg xl:h-nav-xl flex items-center justify-between`}
    >
      <div>
        <Link to="/">
          <img
            src={horizontalLogoGreenImg}
            alt="Acre logo"
            className={`${hideLogoClasses} h-8 md:inline-block hidden`}
          ></img>
          <img
            src={circleLogoGreenImg}
            alt="Acre logo"
            className={`${hideLogoClasses} h-8 md:hidden`}
          ></img>
        </Link>
      </div>
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <NavItem link="/property/list/landing">List Property</NavItem>
        <NavItem link="/explore">Explore</NavItem>
        <NavItem link="/account/properties">Rent/Sell</NavItem>
        <NavItem link="/resources">Resources</NavItem>
      </div>
      <div>
        {!walletContext || !currentWalletState[0] || !wallet ? (
          <>
            {" "}
            <RoundedButton onClick={() => connect()}>
              {connecting
                ? "connecting"
                : "Connect Wallet"}
            </RoundedButton>
          </>
        ) : (
          <>
            <RoundedButton grey={true} link="/account/notifications">
              Account
            </RoundedButton>
            <RoundedButton onClick={async () => {
              await disconnect({label: walletContext.label});
            }}>
              Disconnect
            </RoundedButton>
          </>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
